import AdyenWebCheckout from '@adyen/adyen-web'
import type { Dispatch } from 'react'
import React, { useEffect, useRef } from 'react'
import { isMobile, isTablet } from 'react-device-detect'
import { useDispatch, useSelector } from 'react-redux'
import type { PaymentAction } from 'shared/store/ecommerce/order'
import {
    actionAdyenPaymentResponse,
    sendAdyenPaymentValidation
} from 'shared/store/ecommerce/order'

type AdyenCheckout3DSProps = {
    action: PaymentAction,
    setError: Dispatch<{ message: String, reason?: string }>,
    onSuccess: () => void
}

const getChallengeWindowSize = () => {
    switch (true) {
        case isMobile:
            return '02'
        case isTablet:
            return '03'
        default:
            return '04'
    }
}
export const AdyenCheckout3DS = ({
    action,
    setError,
    onSuccess
}: AdyenCheckout3DSProps) => {
    const paymentContainer = useRef(null)
    const dispatch = useDispatch()
    const { paymentResponse } = useSelector(
        state => state?.ecommerceOrderState?.adyen || {}
    )

    useEffect(() => {
        if (!paymentContainer.current) {
            return
        }

        const createCheckout = async () => {
            const checkout = await AdyenWebCheckout({
                locale: 'fr-FR',
                environment: process.env.REACT_APP_ADYEN_ENVIRONNEMENT,
                clientKey: process.env.REACT_APP_ADYEN_CLIENT_KEY,
                paymentMethodsResponse: paymentResponse,

                onAdditionalDetails: async state => {
                    try {
                        await dispatch(sendAdyenPaymentValidation(state.data))

                        onSuccess()
                    } catch (error) {
                        setError({
                            message:
                                'clickandcollect.payment.error.reason.refused'
                        })
                        dispatch(actionAdyenPaymentResponse(null))
                    }
                },
                onError: (error, _component) => {
                    setError({ message: error.message })
                    dispatch(actionAdyenPaymentResponse(null))
                }
            })

            if (action) {
                checkout
                    .createFromAction(action, {
                        challengeWindowSize: getChallengeWindowSize()
                    })
                    .mount(paymentContainer.current)
            }
        }

        createCheckout()
    }, [action])

    return <div ref={paymentContainer} />
}
